// extracted by mini-css-extract-plugin
export default {"table":"styles_table__nL+gH","roundTrip":"styles_roundTrip__h6XFj"};